import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";


export const ilyaTrades: SeasonTrades[] = [
    {
        season: "2016/17",
        allTrades: [
            {
                otherTeam: manager.yevgeny,
                sentAway: "Marc Gasol and Kris Dunn",
                gotInReturn: "Bradley Beal and Jahlil Okafor"
            },
            {
                otherTeam: manager.yevgeny,
                sentAway: "Al Horford",
                gotInReturn: "Elfrid Payton"
            },
            {
                otherTeam: manager.mati,
                sentAway: "Bradley Beal",
                gotInReturn: "Goran Dragic and Will Barton"
              },
              {
                otherTeam: manager.mati,
                sentAway: "Stephen Curry",
                gotInReturn: "Kevin Durant"
              },
              {
                otherTeam: manager.idan,
                sentAway: "Goran Dragic and Gorgui Dieng", 
                gotInReturn: "Kyle Lowry and Willy Cauley-Stein"
              }
        ]
    },
    {
      season: "2017/18",
      allTrades: [
        {
          otherTeam: manager.yevgeny,
          sentAway: "Blake Griffin", 
          gotInReturn: "Jimmy Butler",
          amongBestTrades: true
        }
      ]
    },
    {
      season: "2018/19",
      allTrades: [
        {
          otherTeam: manager.yevgeny,
          sentAway: "2nd (became Luka Doncic) and 38th picks",
          gotInReturn: "7th and 16th picks",
          amongWorstTrades: true
        },
        {
          otherTeam: manager.zeev,
          sentAway: "Jimmy Butler",
          gotInReturn: "LaMarcus Aldridge"
        },
        {
          otherTeam: manager.zeev,
          sentAway: "DeMar DeRozan",
          gotInReturn: "Marc Gasol"
        },
        {
          otherTeam: manager.mati,
          sentAway: "Kevin Knox",
          gotInReturn: "Julius Randle"
        }
        
      ]
    },
    {
      season: "2019/20",
      allTrades: [
        {
          otherTeam: manager.mati,
          sentAway: "PJ Tucker",
          gotInReturn: "Caris LeVert"
        },
        {
          otherTeam: manager.yevgeny,
          sentAway: "Jrue Holiday",
          gotInReturn: "Clint Capela"
        },
        {
          otherTeam: manager.mati,
          sentAway: "Jaylen Brown",
          gotInReturn: "Marquese Chriss"
        },
        
      ]
    },
    {
      season: "2021/21",
      allTrades: [
        {
          otherTeam: manager.kobe,
          sentAway: "Jerami Grant",
          gotInReturn: "Christian Wood",
          amongBestTrades: true
        },
        {
          otherTeam: manager.mati,
          sentAway: "Gordon Hayward",
          gotInReturn: "DeMar DeRozan"
        }
      ]
    }
]